import { lazy } from 'react';

import { Route } from 'react-router-dom';

// 审批详情
const ApprovalDetailFlowApproveds = lazy(() =>
  import(/* webpackChunkName: "ApprovalDetail" */ 'src/views/FlowApproveds/ApprovalDetail/index')
);
// 审批记录
const ApprovalHistoryFlowApproveds = lazy(() =>
  import(/* webpackChunkName: "ApprovalHistory" */ 'src/views/FlowApproveds/ApprovalHistory/index')
);

const FlowApprovedsApprovalRouter = {
  '/FlowApproveds/ApprovalDetail': ApprovalDetailFlowApproveds,
  '/FlowApproveds/ApprovalHistory': ApprovalHistoryFlowApproveds
};

//  Shop 路由映射关系表
export default function FlowApprovedsPurchaseApprovalRoute() {
  const keys = Object.keys(FlowApprovedsApprovalRouter);
  const routeArr = keys.map(key => {
    const Components = FlowApprovedsApprovalRouter[key];
    return <Route key={key} path={key} element={<Components />} />;
  });
  return routeArr;
}
